export default "__VITE_ASSET__BaYxcHtv__"